import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Master extends BaseApi{
  static getClassName(){ return 'Master' }

  static getFamilyRelation(input){
    return app.make("axios").get(`v1/util/family-relation`,{
      params: {
//        lang:input["i18n"]
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }
}
export default Master



// WEBPACK FOOTER //
// ./src/api/Master.js